var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer',{class:_vm.$style.drawer},[_c('sidebar-links',{class:_vm.$style.sidebar_body,attrs:{"slot":"body","items":_vm.items},slot:"body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }